import { type JsonDataItem } from 'types';
import { baseQuery } from '../baseQuery';

export const getSuburbAvailability = async ({ queryKey }: JsonDataItem) => {
  const [, { suburb, postcode, customerId }] = queryKey;
  const customerParam = customerId ? `&customerID=${customerId}` : '';

  const data = await baseQuery(
    `suburb-postcode-technician-availability?suburb=${suburb}&postcode=${postcode}${customerParam}`,
  );

  return data;
};
